module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('calling-code', {
    staticClass: "area-code"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group phone-number"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.$t('phoneNumPlaceholder')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'input': true, 'danger-border': _vm.errors.has('phone') || !!_vm.phoneErrorMessage
    },
    attrs: {
      "type": "text",
      "name": "phone",
      "id": "phone",
      "placeholder": _vm.$t('phoneNumPlaceholder')
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCaptchaCode($event)
      },
      "blur": function($event) {
        _vm.showErrors.phone = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone') && _vm.showErrors.phone),
      expression: "errors.has('phone') && showErrors.phone"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrors.phone),
      expression: "showErrors.phone"
    }]
  }, [_vm._v(_vm._s(_vm.phoneErrorMessage))])])]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group get-captcha-code"
  }, [_c('label', {
    attrs: {
      "for": "yourCode"
    }
  }, [_vm._v(_vm._s(_vm.$t('verificationPlaceholder')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sendCodeLoading),
      expression: "!sendCodeLoading"
    }],
    attrs: {
      "disabled": _vm.time > 0 || _vm.isDisabled
    },
    on: {
      "click": _vm.getCaptchaCode
    }
  }, [(_vm.time > 0) ? _c('span', {
    staticClass: "wait"
  }, [_vm._v(_vm._s(_vm.$t('sent')) + " " + _vm._s(_vm.time) + " s")]) : _c('span', [_vm._v(_vm._s(_vm.timerText))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:5'),
      expression: "'required|digits:5'"
    }],
    class: {
      'input': true, 'danger-border': _vm.errors.has('verificationCode') || !!_vm.verificationCodeErrorMessage
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "verificationCode",
      "id": "yourCode",
      "placeholder": _vm.$t('verificationPlaceholder')
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "blur": function($event) {
        _vm.showErrors.verificationCode = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('verificationCode') && _vm.showErrors.verificationCode),
      expression: "errors.has('verificationCode') && showErrors.verificationCode"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('verificationCode')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrors.verificationCode),
      expression: "showErrors.verificationCode"
    }]
  }, [_vm._v(_vm._s(_vm.verificationCodeErrorMessage))])])]), _vm._v(" "), (!_vm.isSubmitLoading) ? _c('button', {
    staticClass: "form-submit line-button",
    on: {
      "click": _vm.getResetToken
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('submit')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.isSubmitLoading
    }
  }), _vm._v(" "), _c('captcha', {
    attrs: {
      "phoneNumber": _vm.phoneNumber,
      "captchaSubmitLoading": _vm.captchaSubmitLoading,
      "invalidCode": _vm.invalidCode,
      "getCaptchaCodeLoading": _vm.getCaptchaCodeLoading
    },
    on: {
      "verification": _vm.sendVerificationCode
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34056d16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resetPhonePwd/IndexMain.vue
// module id = 1298
// module chunks = 1